import React, { useEffect, useState } from "react";
import Select from "$components/form-inputs/select";
import { initiativesApi } from "../api";

const SendPartnerInline = ({ initiativeId, onClose, onSent }) => {
    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedOption, setSelectedOption] = useState(null);
    const [sending, setSending] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const controller = new AbortController();
        initiativesApi
            .getPartnerCandidates(initiativeId, controller.signal)
            .then((res) => {
                if (controller.signal.aborted) return;
                const list = res || [];
                setCandidates(list);
                if (list.length === 1) {
                    setSelectedOption({
                        value: String(list[0].crmId),
                        text: `${list[0].crmName} (${list[0].crmEmail})`,
                        _raw: list[0],
                    });
                }
            })
            .finally(() => {
                if (!controller.signal.aborted) setLoading(false);
            });
        return () => controller.abort();
    }, [initiativeId]);

    const send = async () => {
        if (!selectedOption) return;
        const partner = selectedOption._raw;
        setSending(true);
        setError(null);
        try {
            await initiativesApi.sendPartnerToken(
                initiativeId,
                partner.crmId,
                partner.crmName,
                partner.crmEmail
            );
            onSent(partner.crmName);
            onClose();
        } catch {
            setError("Failed to send. Please try again.");
        } finally {
            setSending(false);
        }
    };

    const options = candidates.map((c) => ({
        value: String(c.crmId),
        text: `${c.crmName} (${c.crmEmail})`,
        _raw: c,
    }));

    return (
        <>
            <div className="send-partner-inline__select">
                {loading ? (
                    <span className="txt -small -light">Loading…</span>
                ) : candidates.length === 0 ? (
                    <span className="txt -small -light">No partners with email addresses found.</span>
                ) : (
                    <Select
                        name="partner"
                        options={options}
                        defaultValue={selectedOption}
                        updateOnChange={(name, val) => setSelectedOption(val)}
                    />
                )}
            </div>
            {!loading && candidates.length > 0 && (
                <button
                    className="button -primary -small"
                    disabled={!selectedOption || sending}
                    onClick={send}
                >
                    {sending ? "Sending…" : "Send Review Link"}
                </button>
            )}
            <button className="button -secondary -small" onClick={onClose}>Cancel</button>
            {error && <span className="txt -small -error">{error}</span>}
        </>
    );
};

export default SendPartnerInline;
